module.exports = __webpack_public_path__ + "static/media/yakuza-picture-2.b1bf3e1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/Yakuza/yakuza-picture-2.jpg
// module id = 596
// module chunks = 0